import {Component, OnInit} from '@angular/core';
import {MatError, MatFormField, MatInput, MatLabel} from '@angular/material/input';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatButton} from '@angular/material/button';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {NgIf} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {finalize, tap} from 'rxjs';
import {RecaptchaService} from '../../../services/recaptcha.service';
import {environment} from '../../../../environments/environment';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-contact-us',
  imports: [
    MatLabel,
    MatFormField,
    MatInput,
    MatCheckbox,
    MatButton,
    ReactiveFormsModule,
    FormsModule,
    MatError,
    NgIf,
    TranslatePipe,
  ],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent implements OnInit {

  public formGroup: FormGroup = null;
  public loading = false;
  public submitted = false;

  constructor(private fb: FormBuilder, private http: HttpClient, private recaptcha: RecaptchaService) {
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      name: ['', Validators.required],
      phone: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      message: ['', Validators.required],
      agreement: [false, Validators.requiredTrue],
    })
  }

  async onSubmit() {
    this.formGroup.markAllAsTouched();
    const form = this.formGroup.getRawValue();

    if(this.formGroup.invalid || this.loading) {
      return;
    }
    this.loading = true;

    const recaptchaToken = await this.recaptcha.execute('contact_us');

    this.http.post(`${environment.apiUrl}/contact-us`, form, {
      headers: {'X-Recaptcha-Token': recaptchaToken},
    }).pipe(
      tap(() => {
        this.submitted = true;
        setTimeout(() => {
          this.submitted = false;
        }, 3000)
      }),
      finalize(() => this.loading = false)
    ).subscribe()
  }
}
